import { ListImageModel } from "../../phu-lieu/phu-lieu-model/phu-lieu.model";

export class CommonConFig{

    BUTTON_FORM: any;
    COLOR_STATE: any;
    COLOR_DanhGia:any;

    TOAST_TIME: number;
    REGEX_STR_TO_DDMMYYYY: any;

    REGEX_FORMAT_QUANTITY: any;
    REGEX_FORMAT_QUANTITY_NOTREQUIRED: any;

    REGEX_FORMAT_NUMBER: any;
    REGEX_FORMAT_NUMBER_NOTREQUIRED: any;
    REGEX_FORMAT_NUMBER_NOTREQUIREDNEW: any
    REGEX_PERCENT_NUMBER: any;

    REGEX_SPECIAL_CHARACTER: any;
    REGEX_EXCEPT_ALPHABET_CHARACTER: any;

    PAGE_SIZE_DEFAULT: number = 10;
    PAGE_SIZE_LIST: number[];
    REGEX_FORMAT_ONLYNUMBER:any;
    REGEX_FORMAT_EMAIL:any;

    DEFAULT_NUMBER_VALUE = "0,00";
    DEFAULT_NUMBER_VALUE_NUMBER = "0.00";

    RESPONSE_SUCCESS = 1;
    RESPONSE_FAIL = 0;

    static LYDO_KHONGDUOCXUAT : any[] = [
        {
            id: 1,
            name: 'Hàng chờ kiểm tra'
        },
        {
            id: 2,
            name: 'Hàng KPH'
        },
        {
            id: 3,
            name: 'Hàng trả về từ KH'
        },
    ];

    static TagKho : string[] = ['Không phù hợp', 'Hàng dưới máy', 'Hàng vụn', 'Chờ kiểm tra'];

    constructor(){
        this.BUTTON_FORM = {
            BACK:{
                title: 'Trở lại',
                color: 'default',
                background: 'white',
                icon : 'clear',
                toolTip: '',
                KeyCombine: {
                    description: 'Escape',
                    keycode: 27,
                }
            },
            SAVE_TMP: {
                title: 'Lưu tạm',
                color: 'tmp',
                background: '#b007ed',
                icon : '',
                toolTip: 'Lưu tạm',
                KeyCombine: {
                    description: 'Alt + T',
                    keycode: 84,
                }
            },
            SAVE: {
                title: 'Gửi',
                color: 'accent',
                background: '#2396f9',
                icon : 'check_circle',
                toolTip: 'Gửi',
                KeyCombine: {
                    description: 'Alt + S',
                    keycode: 83,
                }
            },
            SAVE_AND_CLOSE : {
                title: 'Gửi và trở lại',
                color: 'accent',
                background: '#2396f9',
                icon : 'check_circle',
                toolTip: 'Gửi và trở lại',
                KeyCombine: {
                    description: 'Alt + S',
                    keycode: 83,
                }
            },
            SAVE_AND_NEW : {
                title: 'Gửi và thêm mới',
                color: 'primary',
                background: '#001aff',
                icon : '',
                toolTip: 'Lưu và trở lại',
                KeyCombine: {
                    description: 'Alt + B',
                    keycode: 66,
                }
            },
            NOT_CONFIRM : {
                title: 'Không duyệt',
                color: 'warn',
                background: '#de2e29',
                icon : '',
                toolTip: 'Không duyệt',
                KeyCombine: {
                    description: 'Alt + R',
                    keycode: 82,
                }
            },
            CONFIRM : {
                title: 'Duyệt',
                color: 'primary',
                background: '#001aff',
                icon : '',
                toolTip: 'Duyệt',
                KeyCombine: {
                    description: 'Alt + X',
                    keycode: 88,
                }
            },
            DANHANTATCA : {
                title: 'Đóng đề nghị',
                color: 'tmp',
                background: '#7d087d',
                icon : '',
                toolTip: 'Đóng đề nghị',
                KeyCombine: {
                    description: 'Alt + X',
                    keycode: 88,
                }
            },
            DENY : {
                title: 'Từ chối',
                titleLowerCase : 'từ chối',
                color: 'warn',
                background: '#de2e29',
                icon : '',
                toolTip: 'Từ chối',
                KeyCombine: {
                    description: 'Alt + R',
                    keycode: 82,
                }
            },
            GIVEBACK : {
                title: 'Trả lại',
                color: 'warn',
                background: '#de2e29',
                icon : '',
                toolTip: 'Trả lại',
                KeyCombine: {
                    description: 'Alt + G',
                    keycode: 71,
                }
            },
            OK : {
                title: 'Xác nhận',
                color: 'primary',
                background: '#001aff',
                icon : '',
                toolTip: 'Xác nhận',
                KeyCombine: {
                    description: 'Alt + X',
                    keycode: 88,
                }
            },
            IMPORT : {
                title: 'Import file',
                color: 'info',
                background: '#4CAF50',
                icon : '',
                toolTip: 'Import file',
                KeyCombine: {
                    description: 'Alt + I',
                    keycode: 73,
                }
            },
            EXPORT : {
                title: 'Xuất Excel',
                color: 'primary',
                background: '#001aff',
                icon : '',
                toolTip: 'Xuất Excel',
                KeyCombine: {
                    description: '',
                    keycode: 0,
                }
            },
            IMPORT_TEMPLATE : {
                title: 'Tải File mẫu',
                color: 'accent',
                background: '#2396f9',
                icon : 'vertical_align_bottom',
                toolTip: 'Tải File mẫu',
                KeyCombine: {
                    description: 'Alt + F',
                    keycode: 70,
                }
            },
            ADD_NEW : {
                title: 'Thêm mới',
                color: 'primary',
                background: '#001aff',
                icon : '',
                toolTip: 'Thêm mới',
                KeyCombine: {
                    description: 'Alt + N',
                    keycode: 78,
                }
            },
            ADD_NEW_BTN2 : {
                title: 'Thêm mới',
                color: 'primary',
                background: '#001aff',
                icon : '',
                toolTip: 'Thêm mới',
                KeyCombine: {
                    description: 'Alt + M',
                    keycode: 77,
                }
            },
            ADD_NEW_FORECAST : {
                title: 'Thêm forecast',
                color: 'primary',
                background: '#001aff',
                icon : '',
                toolTip: 'Thêm forecast',
                KeyCombine: {
                    description: 'Alt + Q',
                    keycode: 81,
                }
            },
            ADD_NEW_SALE_ORDER: {
                title: 'Thêm đơn hàng bán',
                color: 'primary',
                background: '#001aff',
                icon : '',
                toolTip: 'Thêm đơn hàng bán',
                KeyCombine: {
                    description: 'Alt + N',
                    keycode: 78,
                }
            },
            ADD_MATHANG : {
                title: 'Thêm hàng',
                color: 'primary',
                background: '#001aff',
                icon : 'check_circle',
                toolTip: 'Thêm hàng',
                KeyCombine: {
                    description: 'Alt + H',
                    keycode: 72,
                }
            },
            XACNHAN_PASSHANG : {
                title: 'Xác nhận KQ pass hàng',
                color: 'tmp',
                background: '#001aff',
                icon : '',
                toolTip: 'Xác nhận KQ pass hàng',
                KeyCombine: {
                    description: 'Alt + A',
                    keycode: 65,
                }
            },

            TIEPTUC : {
                title: 'Tiếp tục',
                color: 'accent',
                background: '#2396f9',
                icon : '',
                toolTip: 'Tiếp tục',
                KeyCombine: {
                    description: 'Alt + P',
                    keycode: 80,
                }
            },
            THONGKE : {
                title: 'Thống kê',
                color: 'info',
                icon : 'insert_invitation',
                toolTip: 'Thống kê',
                KeyCombine: {
                    description: 'Alt + C',
                    keycode: 67,
                }
            },

            DAXONG : {
                title: 'Đã xong',
                color: 'tmp',
                background: '#001aff',
                icon : '',
                toolTip: 'Đã xong',
                KeyCombine: {
                    description: 'Alt + A',
                    keycode: 65,
                }
            },
            LUU: {
                title: 'Lưu',
                color: 'accent',
                background: '#2396f9',
                icon : '',
                toolTip: 'Lưu',
                KeyCombine: {
                    description: 'Alt + H',
                    keycode: 72,
                }
            },

            LUUKD: {
                title: 'Lưu',
                color: 'primary',
                background: '#001aff',
                icon : '',
                toolTip: 'Lưu',
                KeyCombine: {
                    description: 'Alt + P',
                    keycode: 80,
                }
            },

            THEMYCDUYETGIA: {
                title: 'Thêm YC duyệt giá',
                color: 'tmp',
                background: '#b007ed',
                icon : '',
                toolTip: 'Thêm YC duyệt giá',
                KeyCombine: {
                    description: 'Alt + T',
                    keycode: 84,
                }
            },
            THEMYCNCSPMOI: {
                title: 'Thêm YCNC SP mới',
                color: 'accent',
                background: '#2396f9',
                icon : '',
                toolTip: 'Thêm YCNC SP mới',
                KeyCombine: {
                    description: 'Alt + S',
                    keycode: 83,
                }
            },

            XACNHANXK_VTKHO: {
                title: 'Xác nhận xuất khỏi VT kho',
                color: 'tmp',
                background: '#b007ed',
                icon : '',
                toolTip: 'Xác nhận xuất khỏi VT kho',
                KeyCombine: {
                    description: 'Alt + S',
                    keycode: 83,
                }
            },

            HUYDONHANG: {
                title: 'Hủy đơn hàng',
                color: 'warn',
                background: '#de2e29',
                icon : '',
                toolTip: 'Hủy đơn hàng',
                KeyCombine: {
                    description: 'Alt + R',
                    keycode: 82,
                }
            },

            CHOTDONHANG : {
                title: 'Chốt đơn hàng',
                color: 'tmp',
                background: '#b007ed',
                icon : '',
                toolTip: 'Chốt đơn hàng',
                KeyCombine: {
                    description: 'Alt + X',
                    keycode: 88,
                }
            },

            DEXUATYCGH : {
                title: 'Đề xuất YCGH',
                color: 'tmp',
                background: '#b007ed',
                icon : '',
                toolTip: 'Đề xuất YCGH',
                KeyCombine: {
                    description: 'Alt + X',
                    keycode: 88,
                }
            },

            DONGYYCGH : {
                title: 'Đồng ý YCGH',
                color: 'accent',
                background: '#2396f9',
                icon : '',
                toolTip: 'Đồng ý YCGH',
                KeyCombine: {
                    description: 'Alt + S',
                    keycode: 83,
                }
            },
            HOANTATKHGHMOI : {
                title: 'Hoàn tất KH giao hàng mới',
                color: 'primary',
                background: '#001aff',
                icon : '',
                toolTip: 'Hoàn tất KH giao hàng mới',
                KeyCombine: {
                    description: 'Alt + B',
                    keycode: 66,
                }
            },

            TIEPNHAN : {
                title: 'Tiếp nhận khiếu nại',
                color: 'primary',
                icon : '',
                toolTip: 'Tiếp nhận khiếu nại',
                KeyCombine: {
                    description: 'Alt + Z',
                    keycode: 90,
                }
            },
            CAPNHATKIEMTRA : {
                title: 'Cập nhật kết quả kiếm tra',
                color: 'accent',
                icon : '',
                toolTip: 'Cập nhật kết quả kiếm tra',
                KeyCombine: {
                    description: 'Alt + V',
                    keycode: 86,
                }
            },
            HOANTAT : {
                title: 'Hoàn tất',
                color: 'primary',
                icon : '',
                toolTip: 'Hoàn tất',
                KeyCombine: {
                    description: 'Alt + D',
                    keycode: 68,
                }
            },
            CHONHANGDNCK : {
                title: 'Chọn hàng từ ĐNCK',
                color: 'info',
                icon : '',
                toolTip: 'Chọn hàng từ ĐNCK',
                KeyCombine: {
                    description: 'Alt + L',
                    keycode: 76,
                }
            },
            THUGON: {
                title: 'Thu gọn',
                color: 'tmp',
                icon : '',
                toolTip: 'Thu gọn',
                KeyCombine: {
                    description: 'Alt + K',
                    keycode: 75,
                }
            },
            MORONG: {
                title: 'Mở rộng',
                color: 'tmp',
                icon : '',
                toolTip: 'Mở rộng',
                KeyCombine: {
                    description: 'Alt + M',
                    keycode: 77,
                }
            },
            CREATECHECKLIST_NCC : {
                title: 'Tạo checklist NCC',
                color: 'tmp',
                background: '#de2e29',
                icon : '',
                toolTip: 'Tạo checklist NCC',
                KeyCombine: {
                    description: 'Alt + R',
                    keycode: 82,
                }
            },
            CREATEVISITSUPPLIER_NCC : {
                title: 'Tạo Visit Supplier',
                color: 'tmp',
                background: '#001aff',
                icon : '',
                toolTip: 'Tạo Visit Supplier',
                KeyCombine: {
                    description: 'Alt + X',
                    keycode: 88,
                }
            },
            KETTHUCDANHGIA : {
                title: 'Kết thúc đánh giá',
                color: 'tmp',
                background: '#001aff',
                icon : '',
                toolTip: 'Kết thúc đánh giá',
                KeyCombine: {
                    description: 'Alt + B',
                    keycode: 66,
                }
            },

            LAYDULIEU: {
                title: 'Lấy dữ liệu',
                color: 'tmp',
                background: '#b007ed',
                icon : '',
                toolTip: 'Lấy dữ liệu',
                KeyCombine: {
                    description: 'Alt + B',
                    keycode: 66,
                }
            },

            DONGDNCHUYENDU: {
                title: 'Đóng đề nghị chuyển đủ',
                color: 'tmp',
                background: '#b007ed',
                icon : '',
                toolTip: 'Đóng đề nghị chuyển đủ',
                KeyCombine: {
                    description: 'Alt + B',
                    keycode: 66,
                }
            },

            CHON_DE_NGHI_TAMUNG: {
                title: 'Chọn đề nghị tạm ứng',
                color: 'primary',
                background: '#001aff',
                icon : '',
                toolTip: 'Chọn đề nghị tạm ứng',
                KeyCombine: {
                    description: 'Alt + N',
                    keycode: 78,
                }
            },

            GHISO : {
                title: 'Ghi sổ',
                color: 'primary',
                background: '#001aff',
                icon : '',
                toolTip: 'Ghi sổ',
                KeyCombine: {
                    description: 'Alt + X',
                    keycode: 88,
                }
            },

            BOGHISO : {
                title: 'Bỏ ghi sổ',
                color: 'warn',
                background: '#de2e29',
                icon : '',
                toolTip: 'Bỏ ghi sổ',
                KeyCombine: {
                    description: 'Alt + R',
                    keycode: 82,
                }
            },

             THUCHIEN: {
                title: 'Thực hiện',
                color: 'primary',
                background: '#001aff',
                icon : '',
                toolTip: 'Thực hiện',
                KeyCombine: {
                    description: 'Alt + N',
                    keycode: 78,
                }
            },


            DOITRU: {
                title: 'Đối trừ',
                color: 'primary',
                background: '#001aff',
                icon : '',
                toolTip: 'Đối trừ',
                KeyCombine: {
                    description: 'Alt + N',
                    keycode: 78,
                }
            },

            BODOITRU: {
                title: 'Bỏ đối trừ',
                color: 'primary',
                background: '#001aff',
                icon : '',
                toolTip: 'Bỏ đối trừ',
                KeyCombine: {
                    description: 'Alt + N',
                    keycode: 78,
                }
            },

            GETDATA: {
                title: 'Lấy dữ liệu',
                color: 'primary',
                background: '#001aff',
                icon : '',
                toolTip: 'Lấy dữ liệu',
                KeyCombine: {
                    description: 'Alt + X',
                    keycode: 88,
                }
            },

            NOT_PostedCashBookManagement : {
                title: 'Hủy ghi sổ quỹ',
                color: 'warn',
                background: '#de2e29',
                icon : '',
                toolTip: 'Hủy ghi sổ quỹ',
                KeyCombine: {
                    description: 'Alt + R',
                    keycode: 82,
                }
            },
            PostedCashBookManagement : {
                title: 'Ghi sổ quỹ',
                color: 'primary',
                background: '#001aff',
                icon : '',
                toolTip: 'Ghi sổ quỹ',
                KeyCombine: {
                    description: 'Alt + X',
                    keycode: 88,
                }
            },
            NOT_PostedCashBookFinance : {
                title: 'Hủy ghi sổ kế toán',
                color: 'warn',
                background: '#de2e29',
                icon : '',
                toolTip: 'Hủy ghi kế toán',
                KeyCombine: {
                    description: 'Alt + R',
                    keycode: 82,
                }
            },
            PostedCashBookFinance : {
                title: 'Ghi sổ kế toán',
                color: 'primary',
                background: '#001aff',
                icon : '',
                toolTip: 'Ghi sổ kế toán',
                KeyCombine: {
                    description: 'Alt + X',
                    keycode: 88,
                }
            },
            Resolve : {
                title: 'Xử lý',
                color: 'primary',
                background: '#001aff',
                icon : '',
                toolTip: 'Xử lý',
                KeyCombine: {
                    description: 'Alt + X',
                    keycode: 88,
                }
            },
            CHON: {
                title: 'Chọn',
                color: 'tmp',
                background: '#b007ed',
                icon : '',
                toolTip: 'Chọn',
                KeyCombine: {
                    description: 'Alt + B',
                    keycode: 66,
                }
            },
            Costing : {
                title: 'Tính giá thành',
                color: 'primary',
                background: '#001aff',
                icon : '',
                toolTip: 'Tính giá thành',
                KeyCombine: {
                    description: 'Alt + X',
                    keycode: 88,
                }
            },
            CostTransfer : {
                title: 'Kết chuyển chi phí',
                color: 'primary',
                background: '#001aff',
                icon : '',
                toolTip: 'Kết chuyển chi phí',
                KeyCombine: {
                    description: 'Alt + B',
                    keycode: 66,
                }
            },
            FactorCostAgg : {
                title: 'Bảng tập hợp chi phí theo yếu tố',
                color: 'primary',
                background: '#001aff',
                icon : '',
                toolTip: 'Bảng tập hợp chi phí theo yếu tố',
                KeyCombine: {
                    description: 'Alt + G',
                    keycode: 71,
                }
            },
            ItemCostAgg : {
                title: 'Bảng tập hợp chi phí theo khoản mục',
                color: 'primary',
                background: '#001aff',
                icon : '',
                toolTip: 'Bảng tập hợp chi phí theo khoản mục',
                KeyCombine: {
                    description: 'Alt + K',
                    keycode: 75,
                }
            },
            Agree : {
                title: 'Đồng ý',
                color: 'primary',
                background: '#001aff',
                icon : '',
                toolTip: 'Đồng ý',
                KeyCombine: {
                    description: 'Alt + K',
                    keycode: 75,
                }
            },
            Allocation : {
                title: 'Phân bổ',
                color: 'primary',
                background: '#001aff',
                icon : '',
                toolTip: 'Phân bổ',
                KeyCombine: {
                    description: 'Alt + K',
                    keycode: 75,
                }
            },
            AllocationNorms : {
                title: 'Định mức phân bổ',
                color: 'primary',
                background: '#001aff',
                icon : '',
                toolTip: 'Định mức phân bổ',
                KeyCombine: {
                    description: 'Alt + X',
                    keycode: 88,
                }
            },
            AllocationNormsByJob : {
                title: 'Định mức phân bổ chi phí theo đối tượng THCP',
                color: 'primary',
                background: '#001aff',
                icon : '',
                toolTip: 'Định mức phân bổ chi phí theo đối tượng THCP',
                KeyCombine: {
                    description: 'Alt + J',
                    keycode: 74,
                }
            },
            Update : {
                title: 'Cập nhật',
                color: 'primary',
                background: '#001aff',
                icon : '',
                toolTip: 'Cập nhật',
                KeyCombine: {
                    description: 'Alt + N',
                    keycode: 78,
                }
            },
            CostInUncomplete : {
                title: 'Tính chi phí dở dang',
                color: 'primary',
                background: '#001aff',
                icon : '',
                toolTip: 'Tính chi phí dở dang',
                KeyCombine: {
                    description: 'Alt + J',
                    keycode: 74,
                }
            },

    PriceofFinishedProducts : {
                title: 'Khai báo định mức giá thành thành phẩm',
                color: 'primary',
                background: '#de2e29',
                icon : '',
                toolTip: 'Khai báo định mức giá thành thành phẩm',
                KeyCombine: {
                    description: 'Alt + R',
                    keycode: 82,
                }
            },

            UnLock : {
                title: 'Bỏ khóa sổ kỳ kế toán',
                color: 'primary',
                background: '#001aff',
                icon : '',
                toolTip: 'Bỏ khóa sổ kỳ kế toán',
                KeyCombine: {
                    description: 'Alt + B',
                    keycode: 66,
                }
            },
            AllocationRate : {
                title: 'Tính tỷ lệ phân bổ',
                color: 'primary',
                background: '#001aff',
                icon : '',
                toolTip: 'Tính tỷ lệ phân bổ',
                KeyCombine: {
                    description: 'Alt + B',
                    keycode: 66,
                }
            },
            CostPrice : {
                title: 'Lấy giá thành định mức',
                color: 'primary',
                background: '#001aff',
                icon : '',
                toolTip: 'Lấy giá thành định mức',
                KeyCombine: {
                    description: 'Alt + R',
                    keycode: 82,
                }
            },
        },

        this.COLOR_STATE = {
            _DangSoanThaoCase: '#FF9900',
            _ChoXacNhanXuLyCase: '#0000FF',
            _ChoXemXetCase: '#027DB4',
            _ChoBGDXacNhanCase: '#6300BF',
            _HoanTatCase: '#009900',
            _HuyCase: '#FF0000',
            _TraHangCase: '#8400FF',
            _ChoKiemTraCase: '#02A7F0',
            _ChoCapNhatHuongXuLyCase: '#F59A23',
            _DangSoanThaoKNKHCase: '#81D3F8',
            _ChoNhanHangCase: '#ff9900'
        },

        this.COLOR_DanhGia = {
            _Tre: '#e70930',
            _Som: '#04a730',
            _DungGio: '#e3a105',


        },

        this.TOAST_TIME = 3000;
        this.REGEX_STR_TO_DDMMYYYY = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/g

        this.REGEX_FORMAT_QUANTITY = '^(([1-9][0-9]{0,2},([0-9]{3},)*)[0-9]{3}(\.[0-9]{1,})?|([1-9]([0-9]+)?)(\.[0-9]{1,})?|[0](\.([1-9][0-9]?|[0][1-9])))$'
        this.REGEX_FORMAT_QUANTITY_NOTREQUIRED = '^(([0-9][0-9]{0,2},([0-9]{3},)*)[0-9]{3}(\.[0-9]{1,})?|([0-9]([0-9]+)?)(\.[0-9]{1,})?|[0](\.([0-9][0-9]?|[0][0-9])))$'

        this.REGEX_PERCENT_NUMBER = '^((0|[1-9]\\d?)\\.\\d{2}|100(\\.00)?)$'; 
        this.REGEX_FORMAT_NUMBER =             '^(([1-9][0-9]{0,2}\.([0-9]{3}\.)*)[0-9]{3}(,[0-9]{1,})?|([1-9]([0-9]+)?)(,[0-9]{1,})?|[0](,([1-9][0-9]?|[0][1-9])))$'; // min 0.01
        this.REGEX_FORMAT_NUMBER_NOTREQUIRED = '^(([0-9][0-9]{0,2}\.([0-9]{3}\.)*)[0-9]{3}(,[0-9]{1,})?|([1-9]([0-9]+)?)(,[0-9]{1,})?|[0](,([1-9][0-9]?|[0][0-9])))$';
        this.REGEX_FORMAT_NUMBER_NOTREQUIREDNEW = '^(?!0+(,0+)?$)(([1-9][0-9]{0,2}\\.(\\d{3}\\.)*)\\d{3}(,\\d{1,})?|([1-9]([0-9]+)?)(,\\d{1,})?|[0](\\.\\d+|,\\d+))$';
        this.REGEX_SPECIAL_CHARACTER = /[a-zA-Z \-!$%^&*()_+|~=`{}[:;<>?@#\]]/g;
        this.REGEX_EXCEPT_ALPHABET_CHARACTER = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
        this.REGEX_FORMAT_ONLYNUMBER = /[0-9]+/;
        this.REGEX_FORMAT_EMAIL = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    }

}

export class NhaCungCapModelLite{
    MaNCC = ""
    TenNCC= ""
    Id_LoaiNCC: number
    Id_Tinh: number
    DiaChi= ""
    DienThoai= ""
    NguoiLienHe= ""

    clear(){
        this.MaNCC = '',
        this.TenNCC = '',
        this.Id_LoaiNCC = 0,
        this.Id_Tinh = 0,
        this.DiaChi = '',
        this.DienThoai = '',
        this.NguoiLienHe = ''
    }
}
export class KhachHangModelLite{
    MaKH = ""
    TenKH= ""
    DiaChi= ""
    DienThoai= ""
    NguoiDaiDien= ""
    IdTinh: number
    IdLoai: number

    clear(){
        this.MaKH = '';
        this.TenKH = '';
        this.DiaChi = '';
        this.DienThoai = '';
        this.NguoiDaiDien = '';
        this.IdLoai = 0;
        this.IdTinh = 0;
    }
}
export class ImportDanhMuc{
    MaNhomHH= ""
    TenNhomHH= ""
    GhiChu= ""
    Id_LoaiHH: number
    isError: boolean
    messageError= ""
    clear(){
        this.MaNhomHH = '';
        this.TenNhomHH = '';
        this.GhiChu = '';
        this.Id_LoaiHH = 0;
        this.isError = false;
        this.messageError = '';
    }
}
export class ImportHangHoa{
    Id_HH : number
    Id_NhomHH : number
    MaHH = ""
    TenHH = ""
    TenNhomHH = ""
    GhiChu = ""
    Disable : boolean
    TenNguoiTao = ""
    NguoiTao : number
    NgayTao = ""
    NguoiSua : number
    NgaySua = ""
    TonKhoToiThieu = ""
    DungSaiChoPhepNhap = ""
    QuyCachDongGoi = ""
    DieuKienBaoQuan = ""
    TonKhoToiDa = ""
    DVT1 : number
    TenDVT1 = ""
    DVT2 : number
    DVT3 : number
    QuyDoiDVT2 = ""
    QuyDoiDVT3 = ""
    HinhDaiDien = ""
    BoPhanKiemTra : number
    TenBoPhanKiemTra = ""
    ThoiHanSuDung : number
    domain= ""
    listKH: any[]
    listNCC: any[]
    tenListNCC: any[]
    listLinkImage: ListImageModel[]
    CanPhieuKt:boolean
    isError: boolean
    messageError= ""
    clear() {
            this.Id_HH = 0;
            this.Id_NhomHH = 0;
            this.MaHH = '';
            this.TenHH = '';
            this.TenNhomHH = '';
            this.GhiChu = '';
            this.Disable = false;
            this.TenNguoiTao = '';
            this.NguoiTao = 0;
            this.NgayTao = '';
            this.NguoiSua = 0;
            this.NgaySua = '';
            this.TonKhoToiThieu = '0.00';
            this.DungSaiChoPhepNhap = '0.00';
            this.QuyCachDongGoi = '';
            this.DieuKienBaoQuan = '';
            this.TonKhoToiDa = '0.00';
            this.DVT1 = 0;
            this.TenDVT1 = '';
            this.DVT2 = 0;
            this.DVT3 = 0;
            this.QuyDoiDVT2 = '0.00';
            this.QuyDoiDVT3 = '0.00';
            this.HinhDaiDien = '';
            this.BoPhanKiemTra = 0;
            this.TenBoPhanKiemTra = '';
            this.ThoiHanSuDung = 0;
            this.domain = '';
            this.listLinkImage = [];
            this.listNCC = [];
            this.tenListNCC = [];
            this.listKH = [];
            this.CanPhieuKt=false;
            this.isError = false;
            this.messageError = '';
    }
    copy(item:ImportHangHoa){
            this.Id_HH = item.Id_HH;
            this.Id_NhomHH = item.Id_NhomHH;
            this.MaHH = item.MaHH;
            this.TenHH = item.TenHH;
            this.TenNhomHH = item.TenNhomHH;
            this.GhiChu = item.GhiChu;
            this.Disable = item.Disable;
            this.TenNguoiTao = item.TenNguoiTao;
            this.NguoiTao = item.NguoiTao;
            this.NgayTao = item.NgayTao;
            this.NguoiSua = item.NguoiSua;
            this.NgaySua = item.NgaySua;
            this.TonKhoToiThieu = item.TonKhoToiThieu;
            this.DungSaiChoPhepNhap = item.DungSaiChoPhepNhap;
            this.QuyCachDongGoi = item.QuyCachDongGoi;
            this.DieuKienBaoQuan = item.DieuKienBaoQuan;
            this.TonKhoToiDa = item.TonKhoToiDa;
            this.DVT1 = item.DVT1;
            this.TenDVT1 = item.TenDVT1;
            this.DVT2 = item.DVT2;
            this.DVT3 = item.DVT3;
            this.QuyDoiDVT2 = item.QuyDoiDVT2;
            this.QuyDoiDVT3 = item.QuyDoiDVT3;
            this.HinhDaiDien = item.HinhDaiDien;
            this.BoPhanKiemTra = item.BoPhanKiemTra;
            this.TenBoPhanKiemTra = item.TenBoPhanKiemTra;
            this.ThoiHanSuDung = item.ThoiHanSuDung;
            this.domain = item.domain;
            this.listLinkImage = item.listLinkImage;
            this.listNCC = item.listNCC;
            this.listKH = item.listKH;
            this.CanPhieuKt=false;
            this.isError = item.isError;
            this.messageError = item.messageError;
            this.tenListNCC = item.tenListNCC;
    }
}
export class HanHoaImportModel{
    MaHH = "";
    TenHH = "";
    IdLoaiHH = 0;
    MaLoaiHH = "";
    TenLoaiHH = "";
    IdNCC = 0;
    MaNCC = "";
    TenNCC = "";
    IdBPKT = 0;
	MaBPKT = "";
	TenBPKT = "";
	IdBPGS = 0;
	TenBPGS = "";
    MaBPGS = "";
    IdDVT1 = 0;
    DVT1 = "";
    DVT2 = "";
    IdDVT2 = 0;
    QuyDoi2Sang1 = "";
    DVT3 = "";
    IdDVT3 = 0;
    QuyDoi3Sang1 = "";
    QuyCach = "";
    MoTa = "";
    SoLuongToiThieu = "";
    DungSaiChoPhep = "";
    DieuKienBaoQuan = "";
    YeuCauPhieuKTHH : boolean;
    MaKho = "";
    IdKho = 0;
    IdKH = 0;
    MaKH = "";
    TenKH = "";
    IsError : boolean[] = new Array(20);
    IsMessage : string[] = new Array(20);

    clear(){
        this.MaHH = "";
        this.TenHH = "";
        this.MaLoaiHH = "";
        this.TenLoaiHH = "";
        this.MaNCC = "";
        this.TenNCC = "";
        this.MaBPKT = "";
        this.TenBPKT = "";
        this.DVT1 = "";
        this.DVT2 = "";
        this.QuyDoi2Sang1 = "";
        this.DVT3 = "";
        this.QuyDoi3Sang1 = "";
        this.QuyCach = "";
        this.MoTa = "";
        this.SoLuongToiThieu = "";
        this.DungSaiChoPhep = "";
        this.DieuKienBaoQuan = "";
        this.YeuCauPhieuKTHH = false;
        this.MaKho = "";
        this.MaKH = "";
        this.TenKH = "";
        this.IsError = new Array(20);
        this.IsMessage = new Array(20);
    }
}
export class SaveHangHoaImportModel{
	BPGS: number;
    BPKT : number
    NCC : number
    IdNhomHH : number
    IdHH : number
    MaHH : string
    TenHH : string
    DVT1 : number
    DVT2 : number
    DVT3 : number
    QuyDoi2Sang1 : number
    QuyDoi3Sang1 : number
    QuyCach : string
    DieuKienBaoQuan : string
    MoTa : string
    SoLuongToiThieu : number
    DungSaiChoPhep : number
    YeuCauPhieuKTHH : boolean
    IdKho : number
    IdKH : number
}

export class TableColumnsImportDM{
    private NGUYENLIEU      = 1;
    private PHULIEU         = 2;
    private THANHPHAM       = 4;
    private BANTHANHPHAM    = 5;
    private BAOBI           = 6;
    private VPP             = 7;
    private VATTU           = 8;
    private TAISAN          = 9;
    private CCDC            = 10;
    private THIETBI         = 11;
    GRPMASTER               = [];
    GRPCOLUMNSNPL           = [];
    GRPCOLUMNSTP            = [];
    GRPCOLUMNSVTTSTB        = [];
    GRPCOLUMNSVPP           = [];
    GRPCOLUMNSCCDC          = [];
    GRPCOLUMNSBTP           = [];
    constructor(){
        // ' Dùng chung '
        this.GRPMASTER = [
            {
                stt: 1,
                name: '#',
                displayName: '#',
                alwaysChecked: false,
                isShow: true,
            },
            {
                stt: 2,
                name: 'Ma',
                displayName: 'Mã nguyên liệu',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 3,
                name: 'Ten',
                displayName: 'Tên nguyên liệu',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 3,
                name: 'DVTC',
                displayName: 'ĐVT chính',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 4,
                name: 'DVT2',
                displayName: 'ĐVT 2',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 5,
                name: 'QuyDoiDVT2',
                displayName: 'Quy đổi ĐVT 2',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 6,
                name: 'DVT3',
                displayName: 'ĐVT 3',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 7,
                name: 'QuyDoiDVT3',
                displayName: 'Quy đổi ĐVT 3',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 8,
                name: 'MaNhom',
                displayName: 'Mã loại hàng hóa',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 9,
                name: 'TenNhom',
                displayName: 'Tên loại hàng hóa',
                alwaysChecked: false,
                isShow: true
            }
        ] 
        // ' Nguyên liệu, phụ liệu, bao bì '
        this.GRPCOLUMNSNPL = this.GRPMASTER.concat([
            {
                stt: 10,
                name: 'MaNCC',
                displayName: 'Mã NCC',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 11,
                name: 'TenNCC',
                displayName: 'Tên NCC',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 12,
                name: 'MOQ',
                displayName: 'MOQ',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 13,
                name: 'DVTMOQ',
                displayName: 'ĐVT MOQ',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 14,
                name: 'LEADTIME',
                displayName: 'Lead Time',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 15,
                name: 'BPKT',
                displayName: 'BPKT',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 16,
                name: 'MOTA',
                displayName: 'Mô tả',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 17,
                name: 'SLTKTT',
                displayName: 'Số lượng TKTT',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 18,
                name: 'DSCP',
                displayName: 'Dung sai cho phép',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 19,
                name: 'QUYCACH',
                displayName: 'Quy cách',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 20,
                name: 'THSD',
                displayName: 'Thời hạn sử dụng',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 21,
                name: 'MAKHO',
                displayName: 'Mã kho',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 22,
                name: 'KHO',
                displayName: 'Kho',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 23,
                name: 'BPGS',
                displayName: 'Bộ phận giám sát',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 24,
                name: 'YCPHIEUKTHH',
                displayName: 'Y/c phiếu KTHH',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 24,
                name: 'DKBQ',
                displayName: 'Điều kiện bảo quản',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 27,
                name: 'Actions',
                displayName: 'Thao tác',
                alwaysChecked: false,
                isShow: true
            }
        ]);
        // ' Bán thành phẩm '
        this.GRPCOLUMNSBTP = this.GRPMASTER.concat([
            /*{
                stt: 10,
                name: 'MaKH',
                displayName: 'Mã KH',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 11,
                name: 'TenKH',
                displayName: 'Tên KH',
                alwaysChecked: false,
                isShow: true
            },*/
            {
                stt: 15,
                name: 'BPKT',
                displayName: 'BPKT',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 16,
                name: 'MOTA',
                displayName: 'Mô tả',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 17,
                name: 'SLTKTT',
                displayName: 'Số lượng TKTT',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 18,
                name: 'DSCP',
                displayName: 'Dung sai cho phép',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 19,
                name: 'QUYCACH',
                displayName: 'Quy cách',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 20,
                name: 'THSD',
                displayName: 'Thời hạn sử dụng',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 21,
                name: 'MAKHO',
                displayName: 'Mã kho',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 22,
                name: 'KHO',
                displayName: 'Kho',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 23,
                name: 'BPGS',
                displayName: 'Bộ phận giám sát',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 24,
                name: 'YCPHIEUKTHH',
                displayName: 'Y/c phiếu KTHH',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 24,
                name: 'DKBQ',
                displayName: 'Điều kiện bảo quản',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 25,
                name: 'PTTVAT',
                displayName: 'Phần trăm thuế VAT (%)',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 26,
                name: 'CBHS',
                displayName: 'Cảnh báo hiệu suất (+/-) %',
                alwaysChecked: false,
                isShow: true
            },
            /*{
                stt: 27,
                name: 'QuyChuan',
                displayName: 'Quy chuẩn',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 28,
                name: 'CanTren',
                displayName: 'Cận trên',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 29,
                name: 'CanDuoi',
                displayName: 'Cận dưới',
                alwaysChecked: false,
                isShow: true
            },*/
            {
                stt: 27,
                name: 'Actions',
                displayName: 'Thao tác',
                alwaysChecked: false,
                isShow: true
            }
        ]);
        // ' Thành phẩm '
        this.GRPCOLUMNSTP = this.GRPMASTER.concat([
            {
                stt: 10,
                name: 'MaKH',
                displayName: 'Mã KH',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 11,
                name: 'TenKH',
                displayName: 'Tên KH',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 15,
                name: 'BPKT',
                displayName: 'BPKT',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 16,
                name: 'MOTA',
                displayName: 'Mô tả',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 17,
                name: 'SLTKTT',
                displayName: 'Số lượng TKTT',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 18,
                name: 'DSCP',
                displayName: 'Dung sai cho phép',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 19,
                name: 'QUYCACH',
                displayName: 'Quy cách',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 20,
                name: 'THSD',
                displayName: 'Thời hạn sử dụng',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 21,
                name: 'MAKHO',
                displayName: 'Mã kho',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 22,
                name: 'KHO',
                displayName: 'Kho',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 23,
                name: 'BPGS',
                displayName: 'Bộ phận giám sát',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 24,
                name: 'YCPHIEUKTHH',
                displayName: 'Y/c phiếu KTHH',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 24,
                name: 'DKBQ',
                displayName: 'Điều kiện bảo quản',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 25,
                name: 'PTTVAT',
                displayName: 'Phần trăm thuế VAT (%)',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 26,
                name: 'CBHS',
                displayName: 'Cảnh báo hiệu suất (+/-) %',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 27,
                name: 'QuyChuan',
                displayName: 'Quy chuẩn',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 28,
                name: 'CanTren',
                displayName: 'Cận trên',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 29,
                name: 'CanDuoi',
                displayName: 'Cận dưới',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 27,
                name: 'Actions',
                displayName: 'Thao tác',
                alwaysChecked: false,
                isShow: true
            }
        ]);
        // ' Vật tư, tài sản, thiết bị '
        this.GRPCOLUMNSVTTSTB = this.GRPMASTER.concat([
            {
                stt: 15,
                name: 'BPKT',
                displayName: 'BPKT',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 16,
                name: 'MOTA',
                displayName: 'Mô tả',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 17,
                name: 'SLTKTT',
                displayName: 'Số lượng TKTT',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 18,
                name: 'DSCP',
                displayName: 'Dung sai cho phép',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 19,
                name: 'QUYCACH',
                displayName: 'Quy cách',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 21,
                name: 'MAKHO',
                displayName: 'Mã kho',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 22,
                name: 'KHO',
                displayName: 'Kho',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 23,
                name: 'BPGS',
                displayName: 'Bộ phận giám sát',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 24,
                name: 'YCPHIEUKTHH',
                displayName: 'Y/c phiếu KTHH',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 24,
                name: 'DKBQ',
                displayName: 'Điều kiện bảo quản',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 27,
                name: 'Actions',
                displayName: 'Thao tác',
                alwaysChecked: false,
                isShow: true
            }
        ]);
        // ' Văn phòng phẩm '
        this.GRPCOLUMNSVPP = this.GRPMASTER.concat([
            {
                stt: 10,
                name: 'MaNCC',
                displayName: 'Mã NCC',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 11,
                name: 'TenNCC',
                displayName: 'Tên NCC',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 15,
                name: 'BPKT',
                displayName: 'BPKT',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 16,
                name: 'MOTA',
                displayName: 'Mô tả',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 17,
                name: 'SLTKTT',
                displayName: 'Số lượng TKTT',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 18,
                name: 'DSCP',
                displayName: 'Dung sai cho phép',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 19,
                name: 'QUYCACH',
                displayName: 'Quy cách',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 21,
                name: 'MAKHO',
                displayName: 'Mã kho',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 22,
                name: 'KHO',
                displayName: 'Kho',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 23,
                name: 'BPGS',
                displayName: 'Bộ phận giám sát',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 24,
                name: 'YCPHIEUKTHH',
                displayName: 'Y/c phiếu KTHH',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 27,
                name: 'Actions',
                displayName: 'Thao tác',
                alwaysChecked: false,
                isShow: true
            }
        ]);
        // ' Công cụ dụng cụ '
        this.GRPCOLUMNSCCDC = this.GRPMASTER.concat([
            {
                stt: 10,
                name: 'MaNCC',
                displayName: 'Mã NCC',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 11,
                name: 'TenNCC',
                displayName: 'Tên NCC',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 12,
                name: 'MOQ',
                displayName: 'MOQ',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 13,
                name: 'DVTMOQ',
                displayName: 'ĐVT MOQ',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 14,
                name: 'LEADTIME',
                displayName: 'Lead Time',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 15,
                name: 'BPKT',
                displayName: 'BPKT',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 16,
                name: 'MOTA',
                displayName: 'Mô tả',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 17,
                name: 'SLTKTT',
                displayName: 'Số lượng TKTT',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 18,
                name: 'DSCP',
                displayName: 'Dung sai cho phép',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 19,
                name: 'QUYCACH',
                displayName: 'Quy cách',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 21,
                name: 'MAKHO',
                displayName: 'Mã kho',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 22,
                name: 'KHO',
                displayName: 'Kho',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 23,
                name: 'BPGS',
                displayName: 'Bộ phận giám sát',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 24,
                name: 'YCPHIEUKTHH',
                displayName: 'Y/c phiếu KTHH',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 27,
                name: 'Actions',
                displayName: 'Thao tác',
                alwaysChecked: false,
                isShow: true
            }
        ]);
    }

    getColumns(idGroup: number){
        if ([this.NGUYENLIEU, this.PHULIEU, this.BAOBI].includes(idGroup))
            return this.GRPCOLUMNSNPL;
        if ([this.BANTHANHPHAM].includes(idGroup))
            return this.GRPCOLUMNSBTP;
        if ([this.THANHPHAM].includes(idGroup))
            return this.GRPCOLUMNSTP;
        if ([this.VATTU, this.TAISAN, this.THIETBI].includes(idGroup))
            return this.GRPCOLUMNSVTTSTB;
        if ([this.VPP].includes(idGroup))
            return this.GRPCOLUMNSVPP;
        if ([this.CCDC].includes(idGroup))
            return this.GRPCOLUMNSCCDC;
        return [];
    }
}
